import {
	Component,
	ViewEncapsulation,
	EventEmitter,
	OnInit,
	OnChanges,
	OnDestroy,
	Input,
	Output
} from "@angular/core";
import { Subscription } from "rxjs/Subscription";

// Interfaces
import { IComponent } from "../../../interfaces";
// Services
import * as Srv from "../../../services";

@Component({
	selector: "app-text-dialog",
	templateUrl: "./text-dialog.component.html",
	styleUrls: ["./text-dialog.component.scss"],
	encapsulation: ViewEncapsulation.None
})
export class TextDialogComponent
	implements IComponent, OnInit, OnDestroy, OnChanges {
	// implements IComponent interfaces
	name = "TextDialogComponent";
	subscriptions: Subscription[] = [];

	// implements local variables
	// *
	constructor(
		private _loggerService: Srv.LogService,
		public dialogService: Srv.DialogService
	) {
		// this.subscriptions.push(
		//   dialogService.OnOpenTextDialog$.subscribe((value: any) => {

		//     this.value = value;
		//   }));
		this.subscriptions.push(
			dialogService.OnClosingTextDialog$.subscribe((value: any) => {})
		);
		this.subscriptions.push(
			dialogService.OnClose$.subscribe((value: any) => {})
		);
	}

	ngOnInit() {}

	ngOnDestroy() {
		this.subscriptions.forEach(s => {
			s.unsubscribe();
		});
		delete this.subscriptions;
	}

	ngOnChanges() {
		// this._loggerService.Debug(this.name, ['inputs:', { value: this.value }]);
	}

	onLeftClick(e: any) {
		this._loggerService.Debug(this.name, [
			this.dialogService.leftButtonText + "Left button clicked",
			e
		]);

		let texttag = this.dialogService.textTag;
		if (
			this.dialogService.textTag.tag == "SITEREVIEW_DIALOG_TOBOARD" ||
			this.dialogService.textTag.tag == "DOWNLOADAPP"
		) {
			this.dialogService.ClickLeftTextDialog(texttag);
			this.dialogService.CloseTextDialog(e);
		} else {
			this.dialogService.CloseTextDialog(e);
		}
	}

	onRightClick(e: any) {
		this._loggerService.Debug(this.name, [
			this.dialogService.rightButtonText + "Right button clicked",
			e
		]);
		this.dialogService.ClickRightTextDialog(e);
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/components/dialog/text-dialog/text-dialog.component.ts